var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingApprove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4633 5.99707C19.2073 5.99707 18.9403 6.08107 18.7453 6.27307L10.0383 14.8671C9.78132 15.1201 9.52333 15.0731 9.32133 14.7751L6.32532 10.3551C6.01932 9.90407 5.37932 9.77807 4.92032 10.0791C4.46232 10.3801 4.33432 11.0091 4.64032 11.4601L7.63532 15.8801C8.53732 17.2091 10.2943 17.3781 11.4433 16.2481L20.1813 7.68506C20.5703 7.30106 20.5703 6.65707 20.1813 6.27307C19.9863 6.08107 19.7183 5.99707 19.4633 5.99707Z",
    fill: "#038F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApprove);
export default __webpack_public_path__ + "static/media/pending-approve.6b6dfc80d7c4464f98a7be781954efe7.svg";
export { ForwardRef as ReactComponent };